import { useSyncExternalStore } from "react";

/**
 * Confirming a sensitive action with a code sent by email (ADR-0076), for people without a
 * passkey here: `withReauth` asks, the layout shows the dialog (loaded only then) and answers.
 */

type Pending = { resolve: (confirmed: boolean) => void } | null;
let pending: Pending = null;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

/** Asks for the code; true once the server accepted it, false if the person gave up. */
export function confirmByEmail(): Promise<boolean> {
  pending?.resolve(false);
  return new Promise((resolve) => {
    pending = { resolve };
    emit();
  });
}

export function answerEmailConfirmation(confirmed: boolean) {
  pending?.resolve(confirmed);
  pending = null;
  emit();
}

export function useEmailConfirmation(): boolean {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => pending !== null,
  );
}
